import { render, staticRenderFns } from "./in-file-2.vue?vue&type=template&id=52178970&scoped=true"
import script from "./in-file-2.vue?vue&type=script&lang=js"
export * from "./in-file-2.vue?vue&type=script&lang=js"
import style0 from "./in-file-2.vue?vue&type=style&index=0&id=52178970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52178970",
  null
  
)

export default component.exports